import { Component, OnInit, OnDestroy, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isThisTypeNode } from 'typescript';
import * as _ from 'lodash';


@Component({
  selector: 'app-riq-alert',
  templateUrl: './riq-alert.component.html',
  styleUrls: ['./riq-alert.component.less']
})
export class RiqAlertComponent implements OnInit {

  @Input() title : string;
  @Input() alertBody: string;
  @Input() htmlMode = false;
  @Input() listMode : boolean = false;
  @Input() showButtons : boolean = true;
  @Input() listItems : any[];
  @Input() cancelButtonText: string;
  @Input() confirmButtonText: string;
  @Input() checkboxLabel: string;
  checkboxChecked: boolean = false;
  @Output() evnt:  EventEmitter<boolean> = new EventEmitter<boolean>();

  /** Leading-edge debounce: first click fires; rapid duplicates within the window are ignored (RIQ-5455). */
  private readonly fireConfirm = _.debounce(
    () => this.evnt.emit(true),
    500,
    { leading: true, trailing: false }
  );

  constructor(
    private toastrService: ToastrService,
    public readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly sanitizer: DomSanitizer
  ) {}

  get safeAlertBody(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.alertBody ?? '');
  }
  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.fireConfirm.cancel();
  }

  save() {
    this.fireConfirm();
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
